import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, indianProjectsBaseURL, uaeProjectsBaseURL } from '../../../../Containers/Config/index.js';
import { UPDATE_CLIENT_ROLE, UPDATE_CLIENT_ROLE_SUCCESS, UPDATE_CLIENT_ROLE_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import cogoToast from 'cogo-toast';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* updateClientRole({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${uaeProjectsBaseURL}/admin/v1/attach-roles`,
      method: 'POST',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        'Project-Code': `ADMIN_ACCESS`,
      },
      data: payload?.data,
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      cogoToast.success(response?.data?.message);
      yield put({
        type: UPDATE_CLIENT_ROLE_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({
        type: UPDATE_CLIENT_ROLE_ERROR,
        payload: response?.data?.message,
      });
    }
  } catch (error) {
    yield put({ type: UPDATE_CLIENT_ROLE_ERROR, payload: error });
  }
}

export function* watchupdateClientRole() {
  yield takeEvery(UPDATE_CLIENT_ROLE, updateClientRole);
}

function* updateClientRoleSaga() {
  yield all([fork(watchupdateClientRole)]);
}

export default updateClientRoleSaga;
